import createIcon from '../../createIcon';

/**
 * @component @name CurrencyRupee
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNjYgN0MxMy4xIDUuODIgMTEuOSA1IDEwLjUgNUg2VjNIMThWNUgxNC43NEMxNS4yMiA1LjU4IDE1LjU4IDYuMjYgMTUuNzkgN0gxOFY5SDE1Ljk4QzE1LjczIDExLjggMTMuMzcgMTQgMTAuNSAxNEg5Ljc3TDE2LjUgMjFIMTMuNzNMNyAxNFYxMkgxMC41QzEyLjI2IDEyIDEzLjcyIDEwLjcgMTMuOTYgOUg2VjdIMTMuNjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyRupee = createIcon('CurrencyRupee', [
  [
    'path',
    {
      d: 'M13.66 7C13.1 5.82 11.9 5 10.5 5H6V3H18V5H14.74C15.22 5.58 15.58 6.26 15.79 7H18V9H15.98C15.73 11.8 13.37 14 10.5 14H9.77L16.5 21H13.73L7 14V12H10.5C12.26 12 13.72 10.7 13.96 9H6V7H13.66Z',
      key: '1q9vr7',
    },
  ],
]);

export default CurrencyRupee;
